import React, { Component } from 'react';
import { DESC } from '../../BaseDataTable';
import { Tooltip } from '@material-ui/core';
import { ArrowUpward, ArrowDownward} from '@material-ui/icons';
import { arrayOf, shape, string, any, func, bool } from 'prop-types';
import { getKeywordColumnWidth } from './../constant';

import classNames from 'classnames';
import styles from './styles.scss';

export default class KeywordTableHead extends Component {
  static propTypes = {
    headers: arrayOf(shape({
      title: string,
      key: string
    })).isRequired,
    tooltipText: string,
    sortKey: string,
    sortStatus: shape({any}),
    onCellClick: func
  }

  static defaultProps = {
    tooltipText: 'Sort'
  }

  drawArrowIcon() {
    const { sortKey, sortStatus } = this.props;
    const arrowIcon = sortStatus[sortKey] === '' || 
                      sortStatus[sortKey] === DESC? 
                      <ArrowDownward className={styles.arrowIcon}/> :
                      <ArrowUpward className={styles.arrowIcon}/>;
    return <span>{arrowIcon}</span>
  }

  drawTableHead() {
    const { headers, sortKey, onCellClick, tooltipText } = this.props;
    return headers && headers.map((header, index) => {
      const { title, key, icon } = header;
      const arrowIcon = sortKey === key && this.drawArrowIcon();
      if (title && key) {
        const width = getKeywordColumnWidth(headers.length, index);
        return (
          <div
            className={classNames(styles.tableCell, styles.tableHeadCell )}
            onClick={onCellClick(key)}
            key={key}
            style={{
              width: `${width}%`
            }}
          >
              <Tooltip className={styles.tooltip} title={tooltipText} placement="top-start">
                <div>
                  {arrowIcon}
                  <span>{title}</span>
                </div>
              </Tooltip>
              {icon}
          </div>
        )
      }
    })
  }
  render() {
    const tableCell = this.drawTableHead();
    return(
      <div className={styles.tableRow}>
        {tableCell}
      </div>
    )
  }
}
